// extracted by mini-css-extract-plugin
export default {"people-bar":"PeopleBar_people-bar__KMp8E","people-container":"PeopleBar_people-container__4aNLI"};